import { createContext } from "react";

export const PopupTooltipContext = createContext(null);
